interface IProps {
  onClose: () => void;
}

const JoinGuideModal_1 = ({ onClose }: IProps): JSX.Element => {
  return (
    <>
      <div className="modal-overlay " id="termsServiceModal">
        <div className="modal-content modal-large">
          <button type="button" className="modal-close" id="termsServiceClose" onClick={onClose}>
            <img src="./images/close-icon.png" alt="닫기" className="modal-close-icon" />
          </button>

          <div className="modal-body">
            <h2 className="modal-title heading-4 font-bold">이용약관 동의</h2>

            <div className="modal-scroll-content">
              <p className="modal-text text-sm font-normal">
                본 약관은 사용자가 본 모바일 웹사이트(이하 "서비스")에 접속하고 사용하는 데 있어 적용되는 규정과 조건을
                정의합니다. 사용자는 본 약관에 동의함으로써 서비스 이용에 대한 권리를 부여받게 됩니다.
              </p>

              <h3 className="modal-subtitle text-base font-bold">1. 약관의 동의와 변경</h3>
              <p className="modal-text text-sm font-normal">
                사용자는 서비스를 이용함으로써 본 약관에 동의하게 됩니다.
                <br />본 회사는 필요에 따라 약관을 변경할 수 있으며, 변경된 약관은 적용일로부터 효력을 발휘합니다.
              </p>

              <h3 className="modal-subtitle text-base font-bold">2. 사용자 계정</h3>
              <p className="modal-text text-sm font-normal">
                사용자는 계정 생성 시 본인의 정확한 정보를 제공해야 합니다.
                <br />
                사용자는 계정 정보의 비밀을 유지할 책임이 있으며, 계정의 모든 활동에 대한 책임은 사용자 본인에게
                있습니다.
              </p>

              <h3 className="modal-subtitle text-base font-bold">3. 서비스 이용</h3>
              <p className="modal-text text-sm font-normal">
                본 서비스는 개인적이고 비상업적인 용도로만 사용할 수 있습니다.
                <br />
                사용자는 법령을 준수하고, 서비스 내에서 불법적이거나 무단의 활동을 금지합니다.
              </p>

              <h3 className="modal-subtitle text-base font-bold">4. 지적재산권</h3>
              <p className="modal-text text-sm font-normal">
                서비스의 모든 콘텐츠 및 소프트웨어는 회사의 지적재산권으로 보호됩니다.
                <br />
                사용자는 회사의 사전 동의 없이 콘텐츠를 복제, 배포, 수정할 수 없습니다.
              </p>
              <h3 className="modal-subtitle text-base font-bold">부칙</h3>
              <p className="modal-text text-sm font-normal">본 약관은 2025년 11월 17일부터 적용됩니다.</p>
            </div>

            <button
              type="button"
              className="modal-button active text-lg font-semibold"
              id="termsServiceConfirm"
              onClick={onClose}
            >
              확인
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default JoinGuideModal_1;
